export const CALENDAR_WEEKDAYS = [
	{ short: 'Mon', long: 'Monday' },
	{ short: 'Tue', long: 'Tuesday' },
	{ short: 'Wed', long: 'Wednesday' },
	{ short: 'Thu', long: 'Thursday' },
	{ short: 'Fri', long: 'Friday' },
	{ short: 'Sat', long: 'Saturday' },
	{ short: 'Sun', long: 'Sunday' },
];

export const CALENDAR_MONTHS = [
	'January',
	'February',
	'March',
	'April',
	'May',
	'June',
	'July',
	'August',
	'September',
	'October',
	'November',
	'December',
];
